import { X, Heart, MessageCircle, Mail, Bell, MessageSquare } from 'lucide-react';
import { useNotificationStore } from '../store/notificationStore';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const NotificationBanner = () => {
  const { isBannerVisible, latestNotification, hideBanner } = useNotificationStore();
  const navigate = useNavigate();

  if (!isBannerVisible || !latestNotification) return null;

  const handleBannerClick = () => {
    hideBanner();
    if (latestNotification.related_id) {
      switch (latestNotification.type) {
        case 'like':
        case 'reply':
          navigate(`/post/${latestNotification.related_id}`);
          break;
        case 'message':
          navigate('/messages');
          break;
        default:
          break;
      }
    }
  };

  const getIcon = () => {
    switch (latestNotification.type) {
      case 'like':
        return <Heart className="w-4 h-4 text-red-500" />;
      case 'reply':
        return <MessageCircle className="w-4 h-4 text-blue-500" />;
      case 'message':
        return <Mail className="w-4 h-4 text-green-500" />;
      case 'reminder':
        return <Bell className="w-4 h-4 text-yellow-500" />;
      case 'comment':
        return <MessageSquare className="w-4 h-4 text-purple-500" />;
      default:
        return <Bell className="w-4 h-4 text-gray-500" />;
    }
  };

  const getTypeLabel = () => {
    switch (latestNotification.type) {
      case 'like':
        return '点赞';
      case 'reply':
        return '回复';
      case 'message':
        return '私信';
      case 'reminder':
        return '提醒';
      case 'comment':
        return '留言';
      default:
        return '通知';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in">
      <div 
        className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 max-w-sm w-full cursor-pointer hover:shadow-2xl transition-shadow"
        onClick={handleBannerClick}
      >
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 p-2 bg-gray-100 rounded-full">
            {getIcon()}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <span className="text-xs font-semibold text-gray-500 uppercase">
                {getTypeLabel()}
              </span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  hideBanner();
                }}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X className="w-4 h-4 text-gray-400" />
              </button>
            </div>
            <p className="text-sm text-gray-800 mt-1 line-clamp-2">
              {latestNotification.content}
            </p>
            <p className="text-xs text-gray-400 mt-2">
              {format(new Date(latestNotification.created_at), 'MM-dd HH:mm')}
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-in {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        .animate-slide-in {
          animation: slide-in 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default NotificationBanner;